module.exports = __webpack_public_path__ + "img/red_cross_icon.c447cd4d.svg";